/* =============================================================
   Shown when the API says this sign-in belongs to an account that was
   deleted (410, migration 023): for example a tab left open on another
   device. apiFetch announces it with an `account-deleted` event; the
   only useful thing left to do is sign out.
   ============================================================ */

import { useEffect, useState } from 'react';
import { signOutEverywhere } from '../lib/msal';

export const ACCOUNT_DELETED_EVENT = 'account-deleted';

export function AccountDeletedNotice() {
  const [gone, setGone] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const on = () => setGone(true);
    window.addEventListener(ACCOUNT_DELETED_EVENT, on);
    return () => window.removeEventListener(ACCOUNT_DELETED_EVENT, on);
  }, []);
  if (!gone) return null;
  return (
    <div role="alert" className="bg-ink text-paper px-6 py-3 text-center font-label text-[13px]">
      This account has been deleted, so nothing here can be saved.{' '}
      <button
        type="button"
        disabled={busy}
        onClick={() => {
          setBusy(true);
          signOutEverywhere().catch(() => setBusy(false));
        }}
        className="underline underline-offset-2 font-semibold disabled:opacity-60"
      >
        {busy ? 'Signing out…' : 'Sign out'}
      </button>
    </div>
  );
}
